var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('personal-section',{attrs:{"title":"常用工具","tabs":_vm.tabs,"classname":"normal-tools"}})}
var staticRenderFns = []

export { render, staticRenderFns }